import React from 'react';
import Helmet from 'react-helmet';
import PageLayout from '../components/PageLayout';

const NotFoundPage = ({location}) => (
  <PageLayout location={location}>
    <Helmet>
      <title>404</title>
    </Helmet>
    <h1>NOT FOUND</h1>
    <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
  </PageLayout>
);

export default NotFoundPage;
